module.exports = __webpack_public_path__ + "img/patient-icon.e840adc9.svg";